import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,ToastController } from 'ionic-angular';
import { Storage } from '@ionic/storage'
import { AuthService } from '../../providers/auth-service'
import { PushProvider } from '../../providers/push/push'
import { ClientesProvider } from '../../providers/clientes/clientes'
import { UtilsProvider } from '../../providers/utils/utils'
import { NUBE_AWS } from '../../config/url.servicio';
import { ParametrosGeneralesRedux } from '../../providers/redux/parametrosgenerales/parametrosgenerales';
/**
 * Generated class for the ParametrosGeneralesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-parametros-creditos',
  templateUrl: 'parametros-creditos.html',
  providers: [ AuthService,PushProvider,UtilsProvider,ParametrosGeneralesRedux ]
})
export class ParametrosCreditosPage {
  CheckEscucharMesas:boolean = false
  CajaDinamica: CajaDinamica[] = []
  CantidadEnVenta: CantidadEnVenta[] = []
  DevolverLaVenta: DevolverVenta[] = []
  ProductoRapidoDesdeCaja: ProductoRapidoCaja[] = []
  BotonActivoImprimir: ValoresActivoImprimir[] = []
  CantidadImpresionCaja: CantidadImpresionesCaja[] = []
  DigitaDetalleCaja: DigitaDetalleCaja[] = []
  ClienteDesdeCaja: ClienteDesdeCaja[] = []
  DetalleReciboEnCaja: DetalleReciboEnCaja[] = []
  DetalleCambiarPrecioEnLosProductos: DetalleCambiarPrecioEnLosProductos[] = []

  cantidadImpresonesCaja: string = "1"
  activoImprimir: string = "S"
  creaProductoRapidoDesdeCaja: string = "S"
  devolverVenta: string = "S"
  digitaCantidadEnVenta: string = "S"
  manejaCajaDinamica: string = "S"
  digitaDescripcionEnCaja: string = "S"
  creaClienteDesdeCaja: string = "S"
  visualizaDetalleReciboEnCaja: string = "S"
  cambiarPrecioEnLosProductos: string = "S"
  creaVentaDesdePedidosSalon: string = "N"
  creaTurno: string = "N"
  manejaDescuentoPorPorcentaje: string = "N"
  DetallecreaVentaDesdePedidosSalon: DetallecreaVentaDesdePedidosSalon[] = []
  DetallecreaTurno: DetallecreaTurno[] = []
  DetallemanejaDescuentoPorPorcentaje: DetallemanejaDescuentoPorPorcentaje[] = []
  inputIP: string = ""
  isValidIP: boolean = true;

  datosPagina:any[] = []
  datosPaginaReal:any[] = []
  recorrerVal:any[]
  nombreCompaniaHeader:any=""
  nombreCargoHeader:any=""
  config: any = {};
  fields: any = [];
  constructor(public navCtrl: NavController, public navParams: NavParams,public storage:Storage,
    public auth: AuthService,
    public servicioPush:PushProvider,
    public toastControllers:ToastController,
    public mensajero: UtilsProvider,
    public utilidades:ClientesProvider,
    public utilsRedux: ParametrosGeneralesRedux) {
    this.dataInicial()
    this.CajaDinamica.push({nombre:"No",valor:"N"},{nombre:"Si", valor:"S"})
    this.CantidadEnVenta.push({nombre:"No",valor:"N"},{nombre:"Si",valor:"S"})
    this.DevolverLaVenta.push({nombre:"No",valor:"N"},{nombre:"Si",valor:"S"})
    this.ProductoRapidoDesdeCaja.push({nombre:"No",valor:"N"},{nombre:"Si",valor:"S"})
    this.BotonActivoImprimir.push({nombre:"No",valor:"N"},{nombre:"Si",valor:"S"})
    this.CantidadImpresionCaja.push({nombre: "1", valor: "1"},{nombre: "2", valor: "2"},{nombre: "3", valor: "3"},{nombre: "4", valor: "4"})
    this.DigitaDetalleCaja.push({nombre:"No",valor:"N"},{nombre:"Si",valor:"S"})
    this.ClienteDesdeCaja.push({nombre: "No", valor: "N"}, {nombre:"Si",valor:"S"})
    this.DetalleReciboEnCaja.push({nombre: "No", valor: "N"}, {nombre:"Si",valor:"S"})
    this.DetalleCambiarPrecioEnLosProductos.push({nombre: "No", valor: "N"}, {nombre:"Si",valor:"S"})
    this.DetallecreaVentaDesdePedidosSalon.push({nombre: "No", valor: "N"}, {nombre:"Si",valor:"S"})
    this.DetallecreaTurno.push({nombre: "No", valor: "N"}, {nombre:"Si",valor:"S"})
    this.DetallemanejaDescuentoPorPorcentaje.push({nombre: "No", valor: "N"}, {nombre:"Si",valor:"S"})

    this.traerDatosIniciales()

  }


  traerDatosIniciales(){

    this.storage.get('companiasId').then((val)=>{
      if(val){
        this.servicioPush.buscarParametrosGeneralesParaMaestro(val)
        .subscribe((dataParametrosGrales)=>{
          let valuesParametrosGenerales
          if(NUBE_AWS) {
            valuesParametrosGenerales = JSON.parse(dataParametrosGrales['_body']).data[0][0]
          } else {
            valuesParametrosGenerales = dataParametrosGrales[0][0]
          }
          this.cantidadImpresonesCaja = valuesParametrosGenerales.cantidadImpresonesCaja.toString();
          this.activoImprimir = valuesParametrosGenerales.activoImprimir;
          this.creaProductoRapidoDesdeCaja = valuesParametrosGenerales.creaProductoRapidoDesdeCaja;
          this.devolverVenta = valuesParametrosGenerales.devolverVenta;
          this.digitaCantidadEnVenta = valuesParametrosGenerales.digitaCantidadEnVenta;
          this.manejaCajaDinamica =  valuesParametrosGenerales.manejaCajaDinamica;
          this.digitaDescripcionEnCaja = valuesParametrosGenerales.digitaDescripcionEnCaja;
          this.creaClienteDesdeCaja = valuesParametrosGenerales.creaClienteDesdeCaja;
          this.visualizaDetalleReciboEnCaja = valuesParametrosGenerales.visualizaDetalleReciboEnCaja;
          this.cambiarPrecioEnLosProductos = valuesParametrosGenerales.cambiarPrecioEnLosProductos;
          this.creaVentaDesdePedidosSalon = valuesParametrosGenerales.creaVentaDesdePedidosSalon;
          this.creaTurno = valuesParametrosGenerales.creaTurno;
          this.manejaDescuentoPorPorcentaje = valuesParametrosGenerales.manejaDescuentoPorPorcentaje;
        },(error)=>{
          console.log(error)
        })
      }
    })


}

  cambiarValoresTabla(){

    this.storage.get('companiasId').then((val)=>{
      if(val){

        this.servicioPush.buscarParametrosGenerales(val)
        .subscribe((valores)=>{
          let id = ''
          if(NUBE_AWS) {
            id = JSON.parse(valores['_body']).data[0][0].parametrosGeneralesId
          } else {
            id = valores[0][0].parametrosGeneralesId
          }

          let data = {}
          data['name']= "dataDynamicCrud"
          data['parametrosGeneralesId']= id
          data['queHago']= "A"
          data['digitaCantidadEnVenta']= this.digitaCantidadEnVenta
          data['manejaCajaDinamica']= this.manejaCajaDinamica
          data['devolverVenta']= this.devolverVenta
          data['creaProductoRapidoDesdeCaja']= this.creaProductoRapidoDesdeCaja
          data['activoImprimir']= this.activoImprimir
          data['cantidadImpresonesCaja']= this.cantidadImpresonesCaja
          data['digitaDescripcionEnCaja']= this.digitaDescripcionEnCaja
          data['creaClienteDesdeCaja'] = this.creaClienteDesdeCaja
          data['visualizaDetalleReciboEnCaja'] = this.visualizaDetalleReciboEnCaja
          data['cambiarPrecioEnLosProductos'] = this.cambiarPrecioEnLosProductos
          data['creaVentaDesdePedidosSalon'] = this.creaVentaDesdePedidosSalon
          data['creaTurno'] = this.creaTurno
          data['manejaDescuentoPorPorcentaje'] = this.manejaDescuentoPorPorcentaje,
          data['ip'] = this.inputIP
          data['nombreTabla']= "parametrosGenerales"

          this.servicioPush.actualizarParametrosGenerales(data)
          .subscribe((nuevoValor)=>{
            this.mensajero.mensajeMuestro('Parametros Caja','Registro actualizado con éxito','success')
          },(error)=>{
            console.log(error)
          })
        },(error)=>{
          console.log(error)
        })

      }
    })

  }

  valoresSelectCajaDinamica(data:string){
    this.manejaCajaDinamica = data
  }

  valoresDigitaCantidadEnVenta(data:string){
    this.digitaCantidadEnVenta = data
  }

  valoresActivoImprimir(data:string){
    this.activoImprimir = data

  }

  valoresCreaProductoRapidoDesdeCaja(data:string){
    this.creaProductoRapidoDesdeCaja = data
  }

  valoresDigitaDevolverVenta(data:string){
    this.devolverVenta = data
  }

  valoresCantidadImprimirCaja(data:string){
    this.cantidadImpresonesCaja = data
  }

  valorDigitaDetalleEnCaja(data: string){
    this.digitaDescripcionEnCaja = data
  }

  valoresCreaClienteDesdeCaja(data: string){
    this.creaClienteDesdeCaja = data
  }

  valoresVisualizaDetalleReciboEnCaja(data: string){
    this.visualizaDetalleReciboEnCaja = data
  }

  valorescambiarPrecioEnLosProductos(data: string){
    this.cambiarPrecioEnLosProductos = data
  }

  valorescambiarCreaVentaDesdePedidosSalon(data: string){
    this.creaVentaDesdePedidosSalon = data
  }

  valorescambiarcreaTurno(data: string){
    this.creaTurno = data
  }

  valorescambiarmanejaDescuentoPorPorcentaje(data: string){
    this.manejaDescuentoPorPorcentaje = data
  }

  cerrarSession(){
    this.auth.logout()
    this.navCtrl.setRoot('LoginPage');
  }

  mensajeToast(mensaje: string) {
    let item =    {
        "duration": 1000,
        "position": "buttom"
      }
      item["message"] = mensaje;
    let toast = this.toastControllers.create(item);
    toast.present();
  }
  validateIP() {
    const ipPattern = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
    this.isValidIP = ipPattern.test(this.inputIP);
    if(!this.isValidIP) {
      this.mensajeToast('Ip no valida')
      this.inputIP = ''
    }
  }

  mapFields(data: any): any[] {
    let fields: any = [];

    for (let key in data) {
      if (data.hasOwnProperty(key)) {
        let field = data[key];

        // Manejo de tipo de campo basado en la estructura de datos
        if (typeof field === 'number' || typeof field === 'string') {
          // Si el campo es número o cadena, conviértelo a número si es posible
          field = typeof field === 'string' ? Number(field) : field;

          fields.push({
            label: this.capitalizeFirstLetter(key.replace(/([A-Z])/g, ' $1')), // Capitaliza la primera letra
            key: key,
            type: typeof field // Puede ser 'number' o 'string'
          });
        } else if (Array.isArray(field)) {
          if (field.length > 0 && typeof field[0] === 'object') {
            // Si es una lista de objetos, probablemente un select o multipleSelect
            fields.push({
              label: this.capitalizeFirstLetter(key.replace(/([A-Z])/g, ' $1')), // Capitaliza la primera letra
              key: key,
              type: 'multipleSelect',
              options: field.map(option => {
                // Manejo seguro de opciones para evitar errores de null/undefined
                let optionKey = Object.keys(option)[0] || '';
                return {
                  key: optionKey, // El nombre de la opción
                  value: option[optionKey] || '' // El valor asociado o cadena vacía si es null
                };
              })
            });
          } else {
            fields.push({
              label: this.capitalizeFirstLetter(key.replace(/([A-Z])/g, ' $1')), // Capitaliza la primera letra
              key: key,
              type: 'list',
              options: field // Asegúrate de que field sea un array válido
            });
          }
        } else if (typeof field === 'object') {
          // Si el campo es un objeto
          let type = field.multipleSelect === 'S' ? 'multipleSelect' : 'select';

          fields.push({
            label: this.capitalizeFirstLetter(key.replace(/([A-Z])/g, ' $1')), // Capitaliza la primera letra
            key: key,
            type: type,
            options: (field.opciones || []).map(option => {
              // Manejo seguro de opciones para evitar errores de null/undefined
              let optionKey = Object.keys(option)[0] || '';
              return {
                key: optionKey, // El nombre de la opción
                value: option[optionKey] || '' // El valor asociado o cadena vacía si es null
              };
            }),
            seleccion: field.multipleSelect === 'S' ?
                        (Array.isArray(field.seleccion) ? field.seleccion : []) :
                        (field.seleccion || []),
              multipleSelect: field.multipleSelect !== undefined && field.multipleSelect === "S" ? "true" : "false"
          });
        }
      }
    }

    return fields;
  }

  onOptionSelect(fieldKey: string, optionKey: string, selected: boolean) {
    const selectedOptions = this.config[fieldKey] || [];

    if (selected) {
      // Agrega la opción seleccionada si no está en el array
      if (!selectedOptions.includes(optionKey)) {
        selectedOptions.push(optionKey);
      }
    } else {
      // Remueve la opción si se deselecciona
      const index = selectedOptions.indexOf(optionKey);
      if (index > -1) {
        selectedOptions.splice(index, 1);
      }
    }
  }


  capitalizeFirstLetter(string: string): string {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  async ionViewDidLoad() {
    this.dataInicial()
  }

 async dataInicial() {
    let companiasId = await this.storage.get('companiasId')
    this.servicioPush.buscarParametrosGeneralesCreditos(companiasId)
    .subscribe(async (data)=>{
      let params = JSON.parse(data['_body'])
      this.config = params.data[0][0].datosCreditos

      this.cargarConfiguracion();
    },(error)=>{
      console.log(error)
    })

  }

  cargarConfiguracion() {
    let data = JSON.parse(this.config)
    this.config = data
    this.fields = this.mapFields(data);
  }
  async guardarConfig(config:any) {
    let companiasId = await this.storage.get('companiasId')
    this.servicioPush.actualizarParametrosGeneralesCreditos(companiasId,config)
    .subscribe(async (data)=>{
      this.mensajeToast('Registro guardado con exito')
      let buscarParametrosGeneralesStore: any = await this.utilsRedux.buscarParametrosGeneralesStore()
      this.utilsRedux.buscarParametrosGeneralesRedux(buscarParametrosGeneralesStore.parametrosGenerales[0].companiasId, buscarParametrosGeneralesStore.parametrosGenerales[0].usuariosId)
    },(error)=>{
      console.log(error)
    })
  }

  onSelectChange(field) {
    console.log('Seleccionado:', field);
    this.actualizarCampo(field.key, this.config[field.key].seleccion,this.config);
  }

  ngOnInit() {
    this.fields = [{"tasaMora":"0","diasHolguraParaMora":"0","cobroInteresPeriodoGracia":{"opciones":[{"No cobra":"N"},{"Distribuido en el tiempo":"D"},{"En la primera cuota":"P"}],"seleccion":"N"},"manejaInteresesEnCuentasDeCobro":{"opciones":[{"No":"N"},{"Si":"S"}],"seleccion":"N"},"visualizaEnSimulacion":{"opciones":[{"key":"interesesCorrientes","value":[{"visualiza":"N"},{"visualiza":"N"}]},{"key":"interesesMora","value":[{"visualiza":"N"},{"visualiza":"N"}]},{"key":"capitalAtrasado","value":[{"visualiza":"N"},{"visualiza":"N"}]},{"key":"costosAdicionales","value":[{"visualiza":"N"},{"visualiza":"N"}]},{"key":"fecha","value":[{"visualiza":"N"},{"visualiza":"N"}]}],"seleccion":[],"multipleSelect":"S"}}]
    // {"tasaMora":"26.5","diasHolguraParaMora":"0","cobroInteresPeriodoGracia":{"opciones":[{"No cobra":"N"},{"Distribuido en el tiempo":"D"},{"En la primera cuota":"P"}],"seleccion":"N"},"manejaInteresesEnCuentasDeCobro":{"opciones":[{"No":"N"},{"Si":"S"}],"seleccion":"S"},"visualizaEnSimulacion":{"opciones":[{"key":"interesesCorrientes","value":[{"visualiza":"S"},{"visualiza":"S"}]},{"key":"interesesMora","value":[{"visualiza":"N"},{"visualiza":"N"}]},{"key":"capitalAtrasado","value":[{"visualiza":"N"},{"visualiza":"N"}]},{"key":"costosAdicionales","value":[{"visualiza":"S"},{"visualiza":"S"}]},{"key":"fecha","value":[{"visualiza":"N"},{"visualiza":"N"}]}],"seleccion":["interesesCorrientes","costosAdicionales"],"multipleSelect":"S"}}
    // {"tasaMora":"40","diasHolguraParaMora":"5","cobroInteresPeriodoGracia":{"opciones":[{"No cobra":"N"},{"Distribuido en el tiempo":"D"},{"En la primera cuota":"P"}],"seleccion":"D"},"manejaInteresesEnCuentasDeCobro":{"opciones":[{"No":"N"},{"Si":"S"}],"seleccion":"S"},"visualizaEnSimulacion":{"opciones":[{"key":"cuantoRestaEnLaCuota","value":[{"visualiza":"N"},{"visualiza":"N"}]},{"key":"montoDeLaCuotaConCostosEintereses","value":[{"visualiza":"N"},{"visualiza":"N"}]},{"key":"montoDeLaCuota","value":[{"visualiza":"N"},{"visualiza":"N"}]},{"key":"interesesCorrientes","value":[{"visualiza":"N"},{"visualiza":"N"}]},{"key":"interesesMora","value":[{"visualiza":"N"},{"visualiza":"N"}]},{"key":"capitalAtrasado","value":[{"visualiza":"N"},{"visualiza":"N"}]},{"key":"costosAdicionales","value":[{"visualiza":"N"},{"visualiza":"N"}]},{"key":"fecha","value":[{"visualiza":"S"},{"visualiza":"S"}]}],"seleccion":["fecha"],"multipleSelect":"S"},"Enviar pago por Whatsaap":{"opciones":[{"No":"N"},{"Si":"S"}],"seleccion":"N"},"Imprimir solo una factura al hacer un pago":{"opciones":[{"No":"N"},{"Si":"S"}],"seleccion":"N"},"visualizaDiaDePago":{"opciones":[{"No":"N"},{"Si":"S"}],"seleccion":"N"},"visualizaExonerarInteresPrimeraCuota":{"opciones":[{"No":"N"},{"Si":"S"}],"seleccion":"N"},"visualizaNumeroDeCuotasExoneradas":{"opciones":[{"No":"N"},{"Si":"S"}],"seleccion":"N"}}
  }

  actualizarCampo(key: string, event: any,config:any) {
    const fieldConfig = this.config[key];
    if (!fieldConfig) {
      console.error('Campo no encontrado en config');
      return;
    }
    const seleccionArray = event;

    if (fieldConfig.opciones && Array.isArray(fieldConfig.opciones)) {
      fieldConfig.seleccion = seleccionArray.filter(val =>
        fieldConfig.opciones.some(option => option.key === val)
      );

          // Ahora actualizamos config con las nuevas selecciones
  const configField = config[key];
  if (configField && configField.opciones) {
    configField.opciones.forEach(option => {
      if (fieldConfig.seleccion.includes(option.key)) {
        // Si la opción está seleccionada, la marcamos como 'S'
        option.value.forEach(v => v.visualiza = 'S');
      } else {
        // Si no está seleccionada, la marcamos como 'N'
        option.value.forEach(v => v.visualiza = 'N');
      }
    });
  }
    } else {
      console.error('Configuración de campo inválida para actualizar');
    }
  }


}

class CajaDinamica {
  public nombre:string;
  public valor:string;
}

class CantidadEnVenta {
  public nombre:string;
  public valor:string;
}

class DevolverVenta {
  public nombre:string;
  public valor:string;
}

class ProductoRapidoCaja{
  public nombre:string;
  public valor:string;
}

class ValoresActivoImprimir{
  public nombre:string;
  public valor:string;
}

class CantidadImpresionesCaja{
  public nombre:string;
  public valor:string;
}

class DigitaDetalleCaja{
  public nombre: string;
  public valor: string;
}

class ClienteDesdeCaja{
  public nombre: string;
  public valor: string;
}

class DetalleReciboEnCaja{
  public nombre: string;
  public valor: string
}

class DetalleCambiarPrecioEnLosProductos {
  public nombre: string;
  public valor: string
}

class DetallecreaVentaDesdePedidosSalon {
  public nombre: string;
  public valor: string
}

class DetallecreaTurno {
  public nombre: string;
  public valor: string
}

class DetallemanejaDescuentoPorPorcentaje {
  public nombre: string;
  public valor: string
}




// WEBPACK FOOTER //
// ./src/pages/parametros-creditos/parametros-creditos.ts